import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import HsocMerchCardGrid from './HsocMerchCardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HsocV2PricingPage = ({
  cards,
  onTermChange
}) => {
  return /*#__PURE__*/_jsxs(View, {
    padding: "800",
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "HSOC_V2_PAGE"
    }), cards && cards.length > 0 ? /*#__PURE__*/_jsx(HsocMerchCardGrid, {
      cards: cards,
      onTermChange: onTermChange
    }) : null]
  });
};